import React from "react";
import classnames from "classnames";
import SearchIcon from "@mui/icons-material/Search";

import "./Search.styles.scss";

interface SearchProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const Search: React.FC<SearchProps> = ({
  placeholder = "Search...",
  className = "",
  inputRef,
  ...props
}) => (
  <div className={classnames("search", className)}>
    <input ref={inputRef} placeholder={placeholder} {...props} />
    <SearchIcon className="search__icon" />
  </div>
);
